import {
  SmartComponentPropertyDetails,
  SmartComponentSummaryData,
} from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";
import { AddressDetails } from "../smart-components/smart-component-property";
import { ComponentAdapterCounterParent } from "./component-adapter-counter-parent";

/**
 * Component adapter for counter distributor
 */
export class ComponentAdapterCounterDistributor
  extends ComponentAdapterCounterParent
  implements IComponentLoader
{
  private _consumption: AddressDetails = null;

  /**
   * Get address about consumption skill
   */
  get Consumption(): AddressDetails {
    return this._consumption;
  }

  constructor() {
    super();
  }

  public fillProperty(
    listSmartComponentSkills: Array<SmartComponentPropertyDetails>,
    data: SmartComponentSummaryData
  ): void {
    this._summary = data.summary;
    this._idSmartComponentKind = data.idSmartComponentKind;
    this._idEnvironment = data.idEnvironment;
    this._name =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_DISTRIBUTOR_NAME
      )?.value || "";
    this._description =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_DISTRIBUTOR_DESCRIPTION
      )?.value || "";
    this._consumption =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_DISTRIBUTOR_CONSUMPTION
      )?.address || null;

    this.fillMissingProperty();
    this.fillAddressState();
  }

  public fillMissingProperty(): void {}

  public fillAddressState(): void {}
}
